import { AbstractControl, ValidationErrors } from "@angular/forms";
import { UserEditFormComponent } from "./user-edit-form.component";

// Validator for fullAddress, addressCompletionId, and addressAutocompleteSessionToken
export function fullAddressWithAutocompleteValidator(component: UserEditFormComponent): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const form = component.userEditForm;
    if (!form) return null;
    const isDirty = form.controls.fullAddress.dirty;
    const addressCompletionId = form.controls.addressCompletionId?.value;
    const addressAutocompleteSessionToken = form.controls.addressAutocompleteSessionToken?.value;
    // If not dirty, only require fullAddress
    if (!isDirty) {
      return control.value ? null : { required: true };
    }
    // If dirty, require all three fields
    const errors: any = {};
    if (!control.value) errors.required = true;
    if (!addressCompletionId) errors.addressCompletionIdRequired = true;
    if (!addressAutocompleteSessionToken) errors.addressAutocompleteSessionTokenRequired = true;
    return Object.keys(errors).length ? errors : null;
  };
}
